export interface DayRange {
  fromDay: number;
  toDay: number;
}

const DAY_MS = 86_400_000;

export const toDayIndex = (ms: number): number => Math.floor(ms / DAY_MS);

export const dayIndexToMs = (day: number): number => day * DAY_MS;
